import { Component, inject } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { Link, UrlPattern } from '@models';

@Component({
  selector: 'app-dataset-form-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
  ],
})
export class DatasetFormLinkComponent {
  dialogRef = inject<MatDialogRef<DatasetFormLinkComponent>>(MatDialogRef);

  public linkForm: FormGroup;
  public isEdit: boolean;
  private _defaultRel: string;

  constructor() {
    const link = inject<Link>(MAT_DIALOG_DATA);

    this.isEdit = !!link;
    this._defaultRel = 'related';

    this.linkForm = new FormGroup({
      href: new FormControl(link?.href, [
        Validators.required,
        Validators.pattern(UrlPattern),
      ]),
      rel: new FormControl(link ? link.rel : this._defaultRel, [
        Validators.required,
      ]),
      title: new FormControl(link?.title),
    });
  }

  public onSubmit() {
    if (this.linkForm.pristine || !this.linkForm.valid) {
      return;
    }

    const data = {
      href: this.linkForm.value.href,
      rel: this.linkForm.value.rel,
    } as Link;

    if (this.linkForm.value.title) {
      data.title = this.linkForm.value.title;
    }

    this.dialogRef.close(data);
  }

  public onCancel() {
    this.dialogRef.close();
  }
}
